"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const date_picker_1 = tslib_1.__importDefault(require("antd/es/date-picker"));
exports.DatePicker = (_a) => {
    var { className, format = 'DD/MM/YYYY' } = _a, props = tslib_1.__rest(_a, ["className", "format"]);
    return (React.createElement(date_picker_1.default, Object.assign({ format: format, dropdownClassName: 'clp-datepicker', className: `clp-datepicker__input ${className}` }, props)));
};
//# sourceMappingURL=DatePicker.js.map